import PRODUCT_TYPE, { SECURED_INSTALLMENT } from 'const/productTypes'
import { ProductType } from '@syf-api-library/account-summary'

/*
 * credit/accounts API product.type returns SecuredInstallment, accountSummary API product.type returns INSTALLMENT_LOAN_SECURED.
 * accountSummary API may change to return SecuredInstallment in the future
 * Will need to update this helper function when that happens
 */

const isAccountTypeSecuredInstallment = (
  type: ProductType | typeof SECURED_INSTALLMENT
) => {
  return [PRODUCT_TYPE.INSTALLMENT_LOAN_SECURED, SECURED_INSTALLMENT].includes(
    type
  )
}

export default isAccountTypeSecuredInstallment
